import React from 'react';
import { Translate } from 'react-redux-i18n';
import logo from '../../../img/logo-idnot.png';
import Contact from '../static/Contact';

export default function ContactPage(): React.ReactElement {
  return (
    <div className="send-activation-code">
      <div className="header">
        <div>
          <img className="logo" src={logo} alt="logo" />
        </div>
        <h3>
          <Translate value="CONTACT.title" />
        </h3>
      </div>
      <Contact hideTitle />
    </div>
  );
}
